module.exports = __webpack_public_path__ + "img/bg.1ce5653c.jpg";